import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import CustomConfiguratorScreen from './App/Screens/ConfiguratorScreen';
import configuratorReducer from './App/Reducers/Configurator/Reducer';
import VisualizationService from './App/Services/VisualizationService';
import DesignDataService from './App/Services/DesignDataService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: 'http://int.weha.local',
  local: 'http://int.weha.local',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  disableBeforeunloadWarning: true,
  screens: {
    Configurator: CustomConfiguratorScreen,
  },
  reducers: {
    configurator: configuratorReducer,
  },
  services: {
    visualization: VisualizationService,
    designData: DesignDataService,
  },
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
